import React from "react";

import { Layout, Menu } from "antd";
import { NavLink, Outlet } from "react-router-dom";

import "./TasksReports.css";
import { GlobalOutlined, ReadOutlined, TeamOutlined } from "@ant-design/icons";
const { Content, Sider } = Layout;

function getItem(label, key, icon, children) {
    return {
        key,
        icon,
        children,
        label,
    };
}

const sidebBarNav = [
    getItem(
        <NavLink to="/tasks/reports/active_workflow" end>Active Workflow Runs</NavLink>,
        "read1",
        <ReadOutlined />
    ),
    getItem(
        <NavLink to="/tasks/reports/assigned_me" >Assigned to Me</NavLink>,
        "read2",
        <ReadOutlined />
    ),
];

const TasksReports = () => {
    return (
        <div className="library" >
            <Layout
                style={{
                    background: "white",
                    height: "auto",
                }}
            >
                <Sider
                    style={{
                        background: "white",
                    }}
                    width={300}
                >
                    <Menu
                        mode="inline"
                        defaultSelectedKeys={["1"]}
                        defaultOpenKeys={["sub1"]}
                        style={{
                            height: "100%",
                            paddingTop: "14px",
                        }}
                        items={sidebBarNav}
                    />
                </Sider>
                <Content
                    style={{
                        padding: "24px 24px 0 24px",
                        minHeight: 280,
                    }}
                >
                    <Outlet />
                </Content>
            </Layout>
        </div>
    );
};

export default TasksReports;
